/* @flow weak */


// if the module has no dependencies, the above pattern can be simplified to
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define('underscore', factory);
    } else if (typeof module === 'object' && module.exports) {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like environments that support module.exports,
        // like Node.
        module.exports = factory(require('underscore'));
    } else {
        // Browser globals (root is window)
        window.helperFunctions = factory(window._);
  }
}(this, function (_) {
	function getJson(url, success, fail) {
        fetch(url)
        	.then(r => r.json())
        	.then(success)
        	.catch(fail);
	}

	var cachedAjax = {};
	function getJsonChached(url, success, fail) {
		if (url in cachedAjax) {
			success(cachedAjax[url]);
		} else {
			getJson(url, function(json) {
				cachedAjax[url] = json;
				success(json);
			}, fail);
		}
	}

	function roughSizeOfObject( object ) {

	    var objectList = [];
	    var stack = [ object ];
	    var bytes = 0;

	    while ( stack.length ) {
	        var value = stack.pop();

	        if ( typeof value === 'boolean' ) {
	            bytes += 4;
	        }
	        else if ( typeof value === 'string' ) {
	            bytes += value.length * 2;
	        }
	        else if ( typeof value === 'number' ) {
	            bytes += 8;
	        }
	        else if
	        (
	            typeof value === 'object'
	            && objectList.indexOf( value ) === -1
	        )
	        {
	            objectList.push( value );

	            for( var i in value ) {
	                stack.push( value[ i ] );
	            }
	        }
	    }
	    return bytes;
	}

	function intersectionObjects2(a, b, areEqualFunction) {
	    var results = [];

	    for(var i = 0; i < a.length; i++) {
	        var aElement = a[i];
	        var existsInB = _.any(b, function(bElement) { return areEqualFunction(bElement, aElement); });

	        if(existsInB) {
	            results.push(aElement);
	        }
	    }

	    return results;
	}

	function intersectionObjects() {
	    var results = arguments[0];
	    var lastArgument = arguments[arguments.length - 1];
	    var arrayCount = arguments.length;
	    var areEqualFunction = _.isEqual;

	    if(typeof lastArgument === "function") {
	        areEqualFunction = lastArgument;
	        arrayCount--;
	    }

	    for(var i = 1; i < arrayCount ; i++) {
	        var array = arguments[i];
	        results = intersectionObjects2(results, array, areEqualFunction);
	        if(results.length === 0) break;
	    }

	    return results;
	}

	function memorizeToLocalStorage(func) {
		if (typeof func != 'function') {
			throw new TypeError(FUNC_ERROR_TEXT);
		}

		let memoized = function() {
			let args = arguments;
			let key = args[0];

			if (key in localStorage) {
				return JSON.parse(localStorage[key]);
			}
			
			let result = func.apply(this, args);
			try {
				localStorage[key] = JSON.stringify(result);
			} catch(e) {
				console.error(e);
			}
			return result;
		};

		return memoized;
	}

	function memorizeToLocalStorageCallback(func, resolver) {
		if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
			throw new TypeError(FUNC_ERROR_TEXT);
		}

		let memoized = function() {
			let args = arguments;
            let key = resolver?resolver.apply(this, args):args[0];

	        return new Promise(function(resolve, reject) {
				if (key in localStorage) {
					resolve(JSON.parse(localStorage[key]));
				} else {
					func.apply(this, args).then((r) => {
						try {
							localStorage[key] = JSON.stringify(r);
						} catch(e) {
							console.error(e);
						}

						resolve(r);
					}).catch(reject);					
				}
			});
		};

		return memoized;
	}
	function qAll(cssSelector) {
		var htmlElements = document.querySelectorAll(cssSelector);

		var htmlElementArray = [];
		var arrayLength = htmlElements.length;
		for (var i = 0; i < arrayLength; ++i) {
		 	htmlElementArray.push(htmlElements[i]);
		}

		return htmlElementArray;
	}
	function q(cssSelector) {
		return document.querySelector(cssSelector);
	}

	const qc = _.memoize(q);
	const qcAll = _.memoize(qAll);

	function emptyArray(a) {
		while(a.length > 0) {
			a.pop();
		}
	}

	function fillArray(a, newItems) {
		emptyArray(a);

		// Push on selected new animal type pathologies
		for (var i = 0; i < newItems.length; ++i) {
		 	a.push(newItems[i]);
		}
	}

	function errorReport(e) {
		console.error('loadingFailed', e);
		console.trace();
		alert(e);
	}


	function globalPreventRedirect() {
		['dragenter', 'dragstart', 'dragend', 'dragleave', 'dragover', 'drag', 'drop'].forEach(eventName => {
			window.addEventListener(eventName,(e) => {
				e = e || event;
				if (!(e.target.tagName.toUpperCase() === "INPUT" && e.target.type.toUpperCase() === "FILE")) { // check wich element is our target
					e.preventDefault();
				}
			},false);
		});
	}

	function removeEmptyValues(object) {
		Object.keys(object)
			.filter(k => object[k] === null)
			.forEach(k => {
				delete object[k];
			});

		Object.keys(object)
			.filter(k => object[k] === undefined)
			.forEach(k => {
				delete object[k];
			});

		Object.keys(object)
			.filter(k => typeof(object[k]) === 'function')
			.forEach(k => {
				delete object[k];
			});

		Object.keys(object)
			.filter(k => typeof(object[k]) === 'string')
			.filter(k => object[k] === '')
			.forEach(k => {
				delete object[k];
			});

		Object.keys(object)
			.filter(k => _.isArray(object[k]))
			.forEach(k => {
				object[k].forEach(o => {
					 removeEmptyValues(o);
				});
			});

		Object.keys(object)
			.filter(k => !_.isArray(object[k]))
			.filter(k => typeof(object[k]) === 'object')
			.forEach(k => {
				 removeEmptyValues(object[k]);
			});
	}

	function allKeyInObjectDeep(object, callback) {
		Object.keys(object)
			.filter(k => !_.isFunction(object[k]) && !(!_.isArray(object[k]) && typeof(object[k]) === 'object'))
			.forEach(k => {
				 callback(object, k);
			});
		Object.keys(object)
			.filter(k => _.isArray(object[k]))
			.forEach(k => {
				_.flattenDeep(object[k])
					.filter(e => !_.isFunction(e) && !_.isArray(e) && typeof(e) === 'object')
					.forEach((e, i) => {
						 allKeyInObjectDeep(e, callback);
					});
			});
		Object.keys(object)
			.filter(k => !_.isFunction(object[k]) && object[k] && !_.isArray(object[k]) && typeof(object[k]) === 'object')
			.forEach(k => {
				 allKeyInObjectDeep(object[k], callback);
			});
	}


	function resetObject(object) {
		Object.keys(object)
			.filter(k => typeof(object[k]) === 'string')
			.forEach(k => {
				object[k] = undefined;
			});
		Object.keys(object)
			.filter(k => typeof(object[k]) === 'boolean')
			.forEach(k => {
				object[k] = undefined;
			});
		Object.keys(object)
			.filter(k => _.isArray(object[k]))
			.forEach(k => {
				while(object[k].length !== 0) {
					object[k].pop();
				}				
			});
		Object.keys(object)
			.filter(k => object[k])
			.filter(k => !_.isArray(object[k]))
			.filter(k => typeof(object[k]) === 'object')
			.forEach(k => {
				 resetObject(object[k]);
			});
	}

	function fileUpload(callback) {
		function makeOnLoadEvent(file) {
			function onLoad(e) {
				callback(e.target.result, file.name, file);
			}

			return onLoad;
		}

		return function () {
			var fileList = this.files;

			for (var i = 0, numFiles = fileList.length; i < numFiles; i++) {

				var file = fileList[i];
			    
			    var reader = new FileReader();
			    reader.onload =  makeOnLoadEvent(file);

			    reader.readAsDataURL(file);
			}
			// this.value = '';
		};
	}

	function serialize(obj) {
		return Object.keys(obj).reduce(function(a,k){
			a.push(k+'='+encodeURIComponent(obj[k]));
			return a;
			}, []).join('&');
	}


	function createPageRedirectEvent(callback) {
		return function (e) {
		    if (this.getAttribute('target') !== '_blank' && this.hostname === location.hostname) {
		        e.preventDefault();

		    	if (this.pathname !== location.pathname || this.search !== location.search) {
		        	e.stopImmediatePropagation();
		        	callback(this, this.pathname + this.search);
		        }
		    }
		};
	}

	function queryParas(url) {
		return url.slice(1)
	        .split('&')
	        .map(function (s) {return s.split('=');})
	        .filter(function (a) {return a[1];})
	        .reduce(function(d, e){
	            d[e[0]] = e[1];
	            return d;
	        }, {});
	}

    return {
    	'getJson': getJson,
    	'getJsonChached': getJsonChached,
    	'qAll': qAll,
    	'q': q,
    	'qcAll': qcAll,
    	'qc': qc,
    	'memorizeToLocalStorage': memorizeToLocalStorage,
    	'memorizeToLocalStorageCallback': memorizeToLocalStorageCallback,
    	'emptyArray': emptyArray,
    	'globalPreventRedirect': globalPreventRedirect,
    	'intersectionObjects': intersectionObjects,
    	'fillArray': fillArray,
    	'errorReport': errorReport,
    	'removeEmptyValues': removeEmptyValues,
    	'resetObject': resetObject,
    	'allKeyInObjectDeep': allKeyInObjectDeep,
    	'serialize': serialize,
    	'roughSizeOfObject': roughSizeOfObject,
    	'fileUpload': fileUpload,
    	'createPageRedirectEvent': createPageRedirectEvent,
    	'queryParas': queryParas
    };
}));
/**
 *    Functions to perform matrix operations on svg elements
*/

/** @namespace svgLayoutDefinition */
function svgMatrixUntilsDefinition() {
    'use strict';

    /** 
    * Get the transform matrix between the 'elem' and the 'relativeTo' element
    * @type {function(SVGElement, SVGElement?):SVGMatrix}
    */
    function getElementMatrix(elem, relativeTo) {
        if (relativeTo && relativeTo !== elem.parentNode) {
            // Avoid this method as it's slow
            
            var hasMatrix = null;
            var startElem = elem;
            while (startElem !== relativeTo.parentNode && startElem !== elem.ownerSVGElement) {
                if (startElem.hasAttribute('transform')) {
                    if (hasMatrix) {
                        return elem.getTransformToElement(relativeTo);
                    }
                    hasMatrix = startElem;
                }
                startElem = startElem.parentNode;
            }

            return hasMatrix?getElementMatrix(hasMatrix):elem.getTransformToElement(relativeTo);
        } else {
            if (elem.transform.baseVal.length === 0 || elem.transform.baseVal.numberOfItems === 0) {
                elem.transform.baseVal.appendItem(elem.ownerSVGElement.createSVGTransform());
            } else if (elem.transform.baseVal.length !== 1 || elem.transform.baseVal.numberOfItems !== 1) {
                elem.transform.baseVal.consolidate();
            }
            return elem.transform.baseVal.getItem(0).matrix;
        }
    }

    function getRotation(elem) {
        return Math.asin(getElementMatrix(elem).b) * (180/3.141);
    }

    function matrixToSvgTransformString(matrix) {
        return 'matrix(' + ['a', 'b', 'c', 'd', 'e', 'f'].map(function(key) {return matrix[key].toFixed(4);}).join(' ') + ')';
    }

    function bboxOfMany(bboxSet) {
        var x = Math.min.apply(null, bboxSet
            .map(function(rect){
                return rect.x;
            }));
        var width = Math.max.apply(null, bboxSet.map(function(rect){
                    return rect.x + rect.width;
                })) - x;
        var y = Math.min.apply(null, bboxSet
            .map(function(rect){
                return rect.y;
            }));
        var height = Math.max.apply(null, bboxSet.map(function(rect){
                    return rect.y + rect.height;
                })) - y;
        return {
            'x': x,
            'y': y,
            'width': width,
            'height': height
        };
    }

    function setRotation(elem, newRotation) {
        var bbox = getBbox(elem);
        var centerX = bbox.x + (bbox.width / 2);
        var centerY = bbox.y + (bbox.height / 2);

        // if (elem.transform.baseVal.length === 0) {
        //     elem.transform.baseVal.appendItem(elem.ownerSVGElement.createSVGTransform());
        // }
        var t = elem.ownerSVGElement.createSVGTransform(); //elem.transform.baseVal.getItem(0);

        t.setRotate(newRotation * (3.141/180), centerX, centerY);

        elem.setAttribute('transform', matrixToSvgTransformString(t.matrix));
    }

    /** @type {function(SVGElement):SVGMatrix} */
    function setElementMatrix(svgElement, matrix) {
        if (svgElement.transform.baseVal.length === 0) {
            svgElement.transform.baseVal.appendItem(svgElement.ownerSVGElement.createSVGTransform());
        }

        svgElement.transform.baseVal.getItem(0).setMatrix(matrix);
    }

    /**
    * Transform rect coordinates by matrix
    * @type {function(!Object, SVGMatrix, SVGElement):!Object}
    */
    function transformRect(bb, matrix, svg) {
        // Create an array of all four points for the original bounding box
        var pts = [
            svg.createSVGPoint(), svg.createSVGPoint(),
            svg.createSVGPoint(), svg.createSVGPoint()
        ];
        pts[0].x=bb.x;          pts[0].y=bb.y;
        pts[1].x=bb.x+bb.width; pts[1].y=pts[0].y;
        pts[2].x=pts[1].x;      pts[2].y=bb.y+bb.height;
        pts[3].x=pts[0].x;      pts[3].y=pts[2].y;

        var transformedPoints = pts.map(function(pt){
            return pt.matrixTransform(matrix);
        });

        var xCoords = transformedPoints.map(function(pt){
            return pt.x;
        });
        var yCoords = transformedPoints.map(function(pt){
            return pt.y;
        });

        var left = Math.min.apply(null, xCoords);
        var top = Math.min.apply(null, yCoords);
        var right = Math.max.apply(null, xCoords);
        var bottom = Math.max.apply(null, yCoords);
        return {
            'x': left,
            'y': top,
            'width': right - left,
            'height': bottom - top
        };
    }

    /** @type {function(SVGElement):!Object} */
    function getBboxOfAllChildren (elem, relativeTo) {
        var bboxs = Array.from(elem.childNodes)
           .filter(function(e) {
                return e.nodeType === 1 && !e.classList.contains('no-distribute');
            })
            .map(function(e) {
                return getBbox(e, relativeTo);
            })
            .filter(function(b) {
                return b.width && b.height;
            });


        return bboxs.length===0?null:bboxOfMany(bboxs);
    }

    /** @type {function(SVGElement):!Object} */
    function getBboxOfChildren (elem, relativeTo) {
        var bboxs = Array.from(elem.childNodes)
           .filter(function(e) {
                return e.nodeType === 1 && !e.classList.contains('no-distribute');
            })
            .map(function(e) {
                return getBbox(e, relativeTo);
            })
            .filter(function(b) {
                return b.width && b.height;
            });

        bboxs = bboxs.length===0?[getBbox(elem)]:bboxs;
        return bboxs;
    }

    /** @type {function(SVGElement)} */
    function removeTransform (elem) {
        var matrix = getElementMatrix(elem);
        console.assert(elem.localName === 'rect' || elem.localName === 'image');

        elem.x.baseVal.value += matrix.e;
        elem.y.baseVal.value += matrix.f;
        
        elem.width.baseVal.value *= matrix.a;
        elem.height.baseVal.value *= matrix.d;

        elem.removeAttribute('transform');
    }


    // Function: svgedit.utilities.getPathBBox
    // Get correct BBox for a path in Webkit
    // Converted from code found here:
    // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
    //
    // Parameters:
    // path - The path DOM element to get the BBox for
    //
    // Returns:
    // A BBox-like object
    function getPathBBox(path) {
        var r = Raphael(10, 50, 600, 300);
        var bbox = r.path(path.getAttribute('d')).getBBox();
        r.remove();

        return bbox;
    }


    /** @type {function(SVGElement):!Object} */
    function getBbox (elem, relativeTo, bugFix, noTransform) {
        var referenceElement = elem;
        var svgDoc = elem.ownerSVGElement || relativeTo.ownerSVGElement;
        referenceElement = elem.correspondingUseElement || referenceElement;
        if (elem.href && elem.href.baseVal) {
            referenceElement = document.getElementById(elem.href.baseVal.substring(1)) || referenceElement;
        }

        var bbox;
        if (elem.localName.toLowerCase() === 'clippath' && !elem.getBBox) {
            referenceElement = referenceElement.firstChild;
            var matrix = getElementMatrix(referenceElement);

            return {
                'x': referenceElement.x.baseVal.value + matrix.e,
                'y': referenceElement.y.baseVal.value + matrix.f,
                'width': referenceElement.width.baseVal.value,
                'height': referenceElement.height.baseVal.value
            };
        }

        if (!referenceElement.getBBox || !svgDoc) {
            return null;
        }

        if (bugFix && elem.localName.toLowerCase() === 'path') {
            bbox = getPathBBox(referenceElement);
        } else {
            try {
                bbox = referenceElement.getBBox();
                bbox = {
                    'x': bbox.x,
                    'y': bbox.y,
                    'width': bbox.width,
                    'height': bbox.height,
                };
            } catch (e) {
                console.log(elem);
                return null;
            }            
        }

        //getComputedTextLength(); http://jsperf.com/comparing-ways-of-getting-svg-text-width/3
        //width = textSelector[0].offsetWidth;
        //height = textSelector[0].offsetHeight;


        if (bbox.width || bbox.height) {
            bbox.y = bbox.y || parseFloat(referenceElement.getAttribute('y')) || 0;
        }

        if (elem.nodeName.toLowerCase() === 'use') {
            bbox.x += elem.x.baseVal.value;
            bbox.y += elem.y.baseVal.value;
        }
        return ((elem.hasAttribute('transform') || relativeTo) && !noTransform)?transformRect(bbox,
                             getElementMatrix(elem, relativeTo),
                             svgDoc):bbox;
    }

    /** @type {function():function} */
    function makeGetBboxCache() {
        if (!window.WeakMap) {
            return getBbox;
        }
        // Make new cache objects
        var bboxCache = new WeakMap();
        var bboxCacheWithChildren = new WeakMap();

        // New getBbox cached function
        var _this = function (elem, relativeTo, children) {
            if (relativeTo) {
                return getBbox(elem, relativeTo);
            }
            if (!children && !bboxCache.has(elem)) {
                var bbox = getBbox (elem);
                if (bbox && bbox.width && bbox.height) {
                    bboxCache.set(elem, bbox);            
                }
            }
            if (children && !bboxCacheWithChildren.has(elem)) {
                bboxCacheWithChildren.set(elem, getBboxOfChildren(elem, relativeTo));            
                return bboxCacheWithChildren.get(elem);
            }

            return bboxCache.get(elem);
        };
        _this.clearCache = function () {
            bboxCache = new WeakMap();
            bboxCacheWithChildren = new WeakMap();
        };
        _this.removeFromCache = function (elem) {
            bboxCache.delete(elem);
            bboxCacheWithChildren.delete(elem);
        };

        return _this;
    }


    return {
        'getRotation': getRotation,
        'setRotation': setRotation,
        'getElementMatrix': getElementMatrix,
        'setElementMatrix': setElementMatrix,
        'getBbox': getBbox,
        'getBboxOfAllChildren': getBboxOfAllChildren,
        'bboxOfMany': bboxOfMany,
        'removeTransform': removeTransform,
        'getBboxOfChildren': getBboxOfChildren,
        'makeGetBboxCache': makeGetBboxCache
    };
}

(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define( [
            ],
            svgMatrixUntilsDefinition );
    }
    window.svgMatrixUntils = svgMatrixUntilsDefinition(window.Raphael);
})(window);

function bindSelectedElementDataDefinition ($, svgMatrixUntils) {
    'use strict';

    function ViewAtributeBindings(domElement, getSelectedElementsFunction, namespaces) {
	    var _this = {};

	    var attributeInputs = Array.from(domElement.querySelectorAll('[data-attribute]'));
	    // var attributeList = {};



	    function getSvgObjectSize(element) {
	    	var box = {};
	        switch (element.nodeName.toLowerCase()) {
	            case 'ellipse':
	                box.x = element.cx.baseVal.value - (element.rx.baseVal.value / 2);
	                box.y = element.cy.baseVal.value - (element.ry.baseVal.value / 2);
	                box.width = element.rx.baseVal.value * 2;
	                box.height = element.ry.baseVal.value * 2;
	                break;
	            case 'circle':
	                box.x = element.cx.baseVal.value - (element.r.baseVal.value / 2);
	                box.y = element.cy.baseVal.value - (element.r.baseVal.value / 2);
	                box.width = element.r.baseVal.value * 2;
	                box.height = element.r.baseVal.value * 2;
	                break;
	            case 'rect':
	            case 'image':
	            case 'foreignObject':
	                box.x = element.x.baseVal.value;
	                box.y = element.y.baseVal.value;
	                box.width = element.width.baseVal.value;
	                box.height = element.height.baseVal.value;
	                break;
	            default:
	                return false;
	        }

	        return box;
	    }

	    function sizeSvgObjectNoTransform(element, width, height) {
	        switch (element.nodeName.toLowerCase()) {
	            case 'ellipse':
	                if (width) {
	                    var positionDiffX = (element.rx.baseVal.value - (width / 2)) ;
	                    element.cx.baseVal.value = element.cx.baseVal.value - positionDiffX;
	                    element.rx.baseVal.value = width/ 2;                    
	                }
	                if (height) {
	                    var positionDiffY = (element.ry.baseVal.value - (height / 2));
	                    element.cy.baseVal.value = element.cy.baseVal.value - positionDiffY;
	                    element.ry.baseVal.value = height/ 2;
	                }
	                break;
	            case 'circle':
	                var newRadius = Math.max(width/ 2, height/ 2);
	                var positionDiff = (element.r.baseVal.value - newRadius) / 2;
	                if (width) {
	                    element.setAttribute('cx', element.cx.baseVal.value - positionDiff);
	                }
	                if (height) {
	                    element.setAttribute('cy', element.cy.baseVal.value - positionDiff);
	                }
	                if (width || height) {
	                    element.r.baseVal.value = Math.max(width/ 2, height/ 2);
	                }
	                break;
	            case 'rect':
	            case 'image':
	                if (width) {
	                    element.setAttribute('width', width);
	                }
	                if (height) {
	                    element.setAttribute('height', height);
	                }
	                break;
	            default:
	                return false;
	        }

	        return true;
	    }

	    function positionSvgObjectNoTransform(element, x, y, scaleX, scaleY) {
	        scaleX = scaleX || 1;
	        scaleY = scaleY || 1;
	        switch (element.nodeName.toLowerCase()) {
	            case 'ellipse':
	                if (x) {
	                    element.cx.baseVal.value = (x + element.rx.baseVal.value) / scaleX;
	                }
	                if (y) {
	                    element.cy.baseVal.value = (y + element.ry.baseVal.value) / scaleY;
	                }
	                break;
	            case 'circle':
	                if (x) {
	                    element.cx.baseVal.value = (x + element.r.baseVal.value) / scaleX;
	                }
	                if (y) {
	                    element.cy.baseVal.value = (y + element.r.baseVal.value) / scaleY;
	                }
	                break;
	            case 'foreignObject':
	            case 'rect':
	            case 'use':
	            case 'image':
	                if (x) {
	                    element.x.baseVal.value = x / scaleX;
	                }
	                if (y) {
	                    element.y.baseVal.value = y / scaleY;
	                }
	                break;
	            default:
	                return false;
	        }

	        return true;
	    }
	    var attributesAdaptor = {
	    	// 'angle' : {
	    	// 	'set': svgMatrixUntils.setRotation,
	    	// 	'get': svgMatrixUntils.getRotation
	    	// }
   	    	'angle' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('norotate')) {
	    				return;
	    			}
	    			svgCanvas.setRotationAngle(newValue, false, e);
	    		},
	    		'get': function () {
	    			var angle = svgCanvas.getRotationAngle() % 360;
	    			while (angle > 360) {
	    				angle -= 360;
	    			}
	    			while (angle < 0) {
	    				angle += 360;
	    			}
	    			return angle;
	    		}
	    	},
   	    	'dimention-x' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('nomove')) {
	    				return;
	    			}
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				positionSvgObjectNoTransform(e, newValue);
	    			} else {
						svgCanvas.changeSelectedAttributeNoUndo('x', newValue, null, true);
	    			}
	    		},
	    		'get': function (e) {
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				return getSvgObjectSize(e).x;
	    			} else {
		    			return svgMatrixUntils.getBbox(e, null, true).x;
		    		}
	    		}
	    	},
   	    	'dimention-y' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('nomove')) {
	    				return;
	    			}
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				positionSvgObjectNoTransform(e, null, newValue);
	    			} else {
						svgCanvas.changeSelectedAttributeNoUndo('y', newValue, null, true);
					}
	    		},
	    		'get': function (e) {
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				return getSvgObjectSize(e).y;
	    			} else {
		    			return svgMatrixUntils.getBbox(e, null, true).y;
		    		}
	    		}
	    	},
   	    	'dimention-width' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('noresize')) {
	    				return;
	    			}
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				sizeSvgObjectNoTransform(e, newValue);
	    			} else {
						svgCanvas.changeSelectedAttributeNoUndo('width', newValue, null, true);
					}
	    		},
	    		'get': function (e) {
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				return getSvgObjectSize(e).width;
	    			} else {
	    				return svgMatrixUntils.getBbox(e, null, true).width;
	    			}
	    		}
	    	},
  	    	'dimention-radius' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('noresize')) {
	    				return;
	    			}
    				sizeSvgObjectNoTransform(e, newValue * 2, newValue * 2);
	    		},
	    		'get': function (e) {
    				return getSvgObjectSize(e).width / 2;
	    		}
	    	},
   	    	'dimention-height' : {
	    		'set': function (e, newValue) {
	    			if (e.classList.contains('noresize')) {
	    				return;
	    			}
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				sizeSvgObjectNoTransform(e, null, newValue);
	    			} else {
						svgCanvas.changeSelectedAttributeNoUndo('height', newValue, null, true);
					}
	    		},
	    		'get': function (e) {
	    			if (['circle', 'rect', 'square', 'ellipse', 'image'].indexOf(e.nodeName.toLowerCase()) !== -1) {
	    				return getSvgObjectSize(e).height;
	    			} else {
		    			return svgMatrixUntils.getBbox(e, null, true).height;
		    		}
	    		}
	    	}
	    };

	    function toUnit(value, unit) {
			return unit==='mm'?
					value / 96 * 25.4:
					value / 96;
	    }
	    function fromUnit(value, unit) {
			return unit==='mm'?
					value * 96 / 25.4:
					value * 96;
	    }

	    // attributeInputs.forEach(function(e) {
	    // 	attributeList[e.getAttribute('data-attribute')] = {
		   //  		'namespace': e.getAttribute('data-namespace'),
		   //  		'values': []
		   //  	};
	    // });

    	attributeInputs.forEach(function(e) {
    		$(e).on('input', inputChangedEvent);
    	});
    	// domElement = null;


    	function undateInputAttribute(element, attributeName) {
			Array.from(domElement.querySelectorAll('[data-attribute~=' + attributeName + ']'))
				.forEach(function(inputEle) {			
					var namespace = inputEle.getAttribute('data-namespace');
					var newValue;

					if (attributeName in attributesAdaptor) {
						newValue = attributesAdaptor[attributeName].get(element);
					} else {
						newValue = element.getAttribute((namespace?namespace + ':':'') + attributeName);
						if (inputEle.type === 'number' || inputEle.type === 'range') {
							newValue = parseFloat(newValue);
						}
					}

					inputEle.value = inputEle.hasAttribute('data-attribute-unit')?
							toUnit(newValue, inputEle.getAttribute('data-attribute-unit')):
							(attributeName === 'name'?decodeURIComponent(newValue):newValue);

					if (inputEle.step && inputEle.step !== 'any') {
						var stepAsNumber = parseFloat(inputEle.step);
						var inverseStep = Math.round(1 / stepAsNumber);
						if ((inputEle.valueAsNumber * inverseStep) % 1 !== 0) {				
							inputEle.value = Math.round(inputEle.valueAsNumber * inverseStep) / inverseStep;
						}
					}
				});
    	}

    	_this.selectionChanged = function () {
			var newSelections = getSelectedElementsFunction()
				.filter(Boolean).filter(function(e) {
					return !e.classList.contains('grips');
				});

    		// newSelections.forEach(function (newSelection) {
    		// 	Object.keys(attributeInputs)
	    	// 		.filter(function(attriName) {
	    	// 			return newSelection.hasAttribute(attriName);
	    	// 		})
	    	// 		.forEach(function() {

	    	// 		});
    		// });

    		if (newSelections.length === 1) {
    			['name', 'depth'].forEach(function(attributeName) {
    				undateInputAttribute(newSelections[0], attributeName);
    			});
    			_this.positionSizeChanged();
    		}
    	};

    	_this.positionSizeChanged = function () {
			var newSelections = getSelectedElementsFunction()
				.filter(Boolean).filter(function(e) {
					return !e.classList.contains('grips');
				});

    		// newSelections.forEach(function (newSelection) {
    		// 	Object.keys(attributeInputs)
	    	// 		.filter(function(attriName) {
	    	// 			return newSelection.hasAttribute(attriName);
	    	// 		})
	    	// 		.forEach(function() {

	    	// 		});
    		// });

    		if (newSelections.length === 1) {
    			['rx', 'angle', 'dimention-x', 'dimention-y',
    					'dimention-width', 'dimention-height', 'dimention-radius'].forEach(function(attributeName) {
    				undateInputAttribute(newSelections[0], attributeName);
    			});
    		}
    	};

	    function inputChanged(element) {
	    	var selectedElements = getSelectedElementsFunction()
	    		.filter(Boolean).filter(function(e) {
	    			return !e.classList.contains('grips');
	    		});

	    	var attributes = element.getAttribute('data-attribute').split(' ');
	    	var value = element.hasAttribute('data-attribute-unit')?
	    			fromUnit(element.value, element.getAttribute('data-attribute-unit')):
	    			element.value;
	    	selectedElements.forEach(function (e) {
		    	attributes.forEach(function (attributeName) {
		    		if (attributeName in attributesAdaptor) {
		    			attributesAdaptor[attributeName].set(e, value);
		    		} else if (element.getAttribute('data-namespace')) {
		    			e.setAttribute(element.getAttribute('data-namespace') + ':' + 
		    						attributeName, value);
		    		} else {
		    			e.setAttribute(attributeName, value);
		    		}
		    	});
	    	});
			moveAllOntoCanvas();
	    	processAlginMarkup();

	        svgEditor.canvas.undoMgr.addCommandToHistory();

	        svgCanvas.getSelectedElems().forEach(function (e) {
	            svgCanvas.selectorManager.requestSelector(e).resize();
	        });
	    }

	    function inputChangedEvent(event) {
            if (this.checkValidity && !this.checkValidity()) {
                return;
            }
            event.stopPropagation();
	    	inputChanged(this);
	    }

	    return _this;
    }

    return ViewAtributeBindings;
}


(function(window) {
    'use strict';
    if ( typeof define === 'function' && define.amd ) {
        // AMD
        define([

        	], bindSelectedElementDataDefinition);
    } else {
        // browser global
        window.bindSelectedElementData = bindSelectedElementDataDefinition(jQuery, svgMatrixUntils);
    }
})(window);